//AUTH
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const REGISTER_START = "REGISTER_START";
export const FACEBOOK_AUTH_FAILED = "FACEBOOK_AUTH_FAILED";
export const GOOGLE_AUTH_FAILED = "GOOGLE_AUTH_FAILED";
export const FORGET_PASSWORD_EMAIL_SENT = "FORGET_PASSWORD_EMAIL_SENT";
export const FORGET_PASSWORD_FAILED = "FORGET_PASSWORD_FAILED";
export const START_FORGET_PASSWORD = "START_FORGET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR";
export const VERTIFICATION_SEND_START="VERTIFICATION_SEND_START";
export const VERTIFICATION_SENT="VERTIFICATION_SENT";
export const CLEAR_AUTH_MESSAGE = "CLEAR_AUTH_MESSAGE";

// languages
export const SET_LANGUAGES = "SET_LANGUAGES";
export const LANGUAGES_FAILED = "LANGUAGES_FAILED";
export const LANGUAGE_CHANGED = "LANGUAGE_CHANGED";
export const SET_TRANSILATIONS = "SET_TRANSILATIONS";
export const CHANGE_LANGUAGE_STARTED="CHANGE_LANGUAGE_STARTED"
export const CHANGE_LANGUAGE_END="CHANGE_LANGUAGE_END"

// User Profile
export const SET_USER_PROFILE="SET_USER_PROFILE"
export const ERROR_FETCH_USER_PROFILE="ERROR_FETCH_USER_PROFILE"
export const DELETE_USER_PROFILE="DELETE_USER_PROFILE"
export const CLEAR_USER_PROFILE_ERROR="CLEAR_USER_PROFILE_ERROR"